import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import RAG_SYSTEMS from '../../config/systems';
import Button from '../common/Button';
import SystemCard from './SystemCard';
import './DemoSelection.css';

function DemoSelection() {
  const [selectedId, setSelectedId] = useState(null);
  const navigate = useNavigate();

  const selectedSystem = RAG_SYSTEMS.find(s => s.id === selectedId);

  const handleConfirm = () => {
    if (selectedSystem && !selectedSystem.disabled) {
      window.location.href = selectedSystem.url;
    }
  };

  return (
    <div className="demo-selection">
      <div className="demo-selection__container">
        <button className="demo-selection__back" onClick={() => navigate('/')}>
          ← 돌아가기
        </button>
        <h1 className="demo-selection__title">RAG 시스템 선택</h1>
        <p className="demo-selection__subtitle">체험할 RAG 시스템을 선택해주세요.</p>

        <div className="demo-selection__list">
          {RAG_SYSTEMS.map(system => (
            <SystemCard
              key={system.id}
              system={system}
              isSelected={selectedId === system.id}
              onSelect={setSelectedId}
            />
          ))}
        </div>

        <div className="demo-selection__actions">
          <Button
            onClick={handleConfirm}
            disabled={!selectedSystem || selectedSystem.disabled}
          >
            확인
          </Button>
        </div>
      </div>
    </div>
  );
}

export default DemoSelection;
